module.exports = __webpack_public_path__ + "static/media/GraphicCardA0246_bg_clean_v001.d6803e9e.webp";